import * as React from 'react';
import { Link } from 'react-router-dom';
import vettingLogoPng from '../../images/vetting-logo.png';
import { Logo } from '../../models/be/Branding';
import { withCacheBuster } from '../../lib/utils';
import './logos.less';

export const LoginLogo = (props: Props) =>
	props.logo && (
		<Link to={{ pathname: '/' }} id="indexLink" className="imgWrapper">
			<img
				className="vettingLogo"
				src={withCacheBuster(props.logo?.url)}
				width={props.logo?.width}
				height={props.logo?.height}
				alt="Logo"
			/>
		</Link>
	);

interface Props {
	logo?: Logo;
}

LoginLogo.defaultProps = {
	logo: null
};

export const ReportLogo = () => <img src={vettingLogoPng} alt="Logo" />;
